import { ApolloClient, InMemoryCache } from '@apollo/client'
import staticConfig from 'src/config'
import { networksEnvironments } from 'src/config/networks'
import { createRetryLink, mergeEntities } from './utils'

const defaultNetworkEnv = networksEnvironments[staticConfig.defaultChain.id]

const link = createRetryLink(defaultNetworkEnv.subgraphUrls.main)

const swarmXClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          offers: {
            keyArgs: ['id', 'where'],
            merge: mergeEntities,
          },
        },
      },
    },
  }),
})

export default swarmXClient
